import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { ExpenseBillingWorksheetStateClass } from './interfaces/ExpenseBillingWorksheetStateClass'

const initialState: ExpenseBillingWorksheetStateClass = {
    isLoading:true,
    status: 'idle',
    expenseBillingWorksheetList: [],
    selectedRecord: {},
    isReload: false,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    start: 0,
    search: " ",
    recordsFiltered: 0,
    timeEntryArchiveCheckedIds: [],
    isAllUnChecked: true,
    optionClientNameValue: "0",
    optionClientNameText: "All",
    optionEmployeeNameValue: "0",
    optionEmployeeNameText: "All",
    optionProjectValue: "0",
    optionProjectText: "All",
    optionExpenseNameValue: "0",
    optionExpenseNameText: "All",
    optionExpenseTypeValue: "0",
    optionExpensTypeText: "All",
    optionBilledValue: "-1",
    optionBilledText: "Both",
    columnIndex:0,
    direction:"asc",
    sortOrder: 'asc',
    sortColumn: '1',
    pageNo: 1,
    startDate: (() => {
        const newDate = new Date();
        newDate.setMonth(newDate.getMonth() - 2);
        return newDate.toISOString();
    })(),
    endDate: new Date().toISOString(),
    isChecked: false,
    checkedItems: []
}
interface IThunkApi {
    state: {
        expenseBillingWorksheet: ExpenseBillingWorksheetStateClass;
    },
}
export const getExpenseBilingWorksheetForDatatableAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Invoice/V2/ExpenseBilingWorksheetForDatatable',
        async (arg, thunkApi) => {
            const { currentPage, pageSize, start, search, SearchParamsValues } = arg;
            const trimmedSearchParamsValues = SearchParamsValues.trim();
            const trimmedSearch = search.trim();
            const { sortOrder, sortColumn } = thunkApi.getState().expenseBillingWorksheet;
            const encodedData = {
                currentPage:currentPage,
                pageSize:pageSize,
                start:start,
                orderDir:sortOrder,
                order:sortColumn,
                SearchParamsValues:trimmedSearchParamsValues,
                search: trimmedSearch
              };         
            
            const response = await fetchAPI(
                'api/V2/Invoice/ExpenseBilingWorksheetForDatatable/'+SearchParamsValues,
                'POST',
                encodedData,
                true,
                '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab'
            );

            const json = await response.json();
            return json;
        }
    )


    export const updateExpenseBillingWorksheetAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expense/SubmitExpenseSheet',
        async (arg, thunkApi) => {
            const { AccountExpenseEntryId, BillingsWorkSheetList} = arg;
            const response = await fetchAPI('api/V2/Invoice/UpdateExpenseBillingWorkSheet', 'Post', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const expenseBillingSlice = createSlice({
    name: 'expenseBillingWorksheet',
    initialState,
    reducers: {        
        resetSelectedRecordObjectInState: (state) => {
            state.expenseBillingWorksheetList = [];
            state.timeEntryArchiveCheckedIds = [];
        }, 
        Edit: (state, action) => {
            state.selectedRecord = action.payload;
        },
        setOptionClientNameValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionClientNameValue = value;
            state.optionClientNameText = label;
        },
        setOptionEmployeeNameValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionEmployeeNameValue = value;
            state.optionEmployeeNameText = label;
        },
        setOptionProjectValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionProjectValue = value;
            state.optionProjectText = label;
        },
        setOptionExpenseNameValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionExpenseNameValue = value;
            state.optionExpenseNameText = label;
        },
        setOptionExpenseTypeValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionExpenseNameValue = value;
            state.optionExpenseNameText = label;
        },        
       
        setOptionBilledValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionBilledValue = value;
            state.optionBilledText = label;
        },
        setDateRangeValue: (state, action) => {
            const { startDate, endDate } = action.payload;
            state.startDate = startDate;
            state.endDate = endDate;
        },
       
        setSearchValue: (state, action) => {
            state.search = action.payload;
            state.currentPage = 1;
        },
        setPageSizeValue: (state, action) => {
            state.pageSize = action.payload;
            state.currentPage = 1;
        },
        setSortConfig: (state, action) => {
            const {columnIndex,direction} = action.payload;
            let ndirection = 'asc';
            if (state.columnIndex === columnIndex && state.direction === 'asc') {
                ndirection = 'desc';
            }
            state.direction = ndirection;
            state.columnIndex = columnIndex;           
         },
        checkedBilledState: (state, action) => {
            const currentindex = state.expenseBillingWorksheetList.findIndex((item) => item.AccountExpenseEntryId == action.payload);
            const newArray = [...state.expenseBillingWorksheetList];
            newArray[currentindex] = { ...newArray[currentindex], Billed: true };
            state.expenseBillingWorksheetList = newArray;
        },
        unCheckedBilledState: (state, action) => {
            const currentindex = state.expenseBillingWorksheetList.findIndex((item) => item.AccountExpenseEntryId == action.payload);
            const newArray = [...state.expenseBillingWorksheetList];
            newArray[currentindex] = { ...newArray[currentindex], Billed: false };
            state.expenseBillingWorksheetList = newArray;
        },
       
        resetCheckedState: (state) => {
            state.expenseBillingWorksheetList = state.expenseBillingWorksheetList.map(item => ({
                ...item,
                Billed: false
            }));
        },

        updateSorting: (state, action: PayloadAction<any>) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.start = action.payload.start;
            state.pageSize = action.payload.pageSize;
            state.currentPage = action.payload.currentPage;
        }

    },
    
    extraReducers: (builder) => {
        builder
            .addCase(getExpenseBilingWorksheetForDatatableAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getExpenseBilingWorksheetForDatatableAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                if (payload.data !== undefined) {
                    state.expenseBillingWorksheetList = JSON.parse(payload.data);
                    state.isReload = false;
                    state.selectedRecord = {};
                    state.currentPage = payload.currentPage;
                    state.start = payload.start;
                    state.totalItems = payload.recordsTotal;
                    state.search = payload.search;
                    state.recordsFiltered = payload.recordsFiltered;                  
                }
            })
            .addCase(getExpenseBilingWorksheetForDatatableAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })  


            .addCase(updateExpenseBillingWorksheetAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true; 
            })
            .addCase(updateExpenseBillingWorksheetAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false; 
            })
            .addCase(updateExpenseBillingWorksheetAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false; 
            })
    }
})

export const {
     Edit,
    setOptionBilledValue, setOptionClientNameValue, setOptionEmployeeNameValue
    , setOptionProjectValue, setOptionExpenseNameValue, setDateRangeValue,
    setSearchValue, setPageSizeValue,setSortConfig, resetSelectedRecordObjectInState,setOptionExpenseTypeValue,checkedBilledState,unCheckedBilledState,updateSorting
} = expenseBillingSlice.actions
export const ExpenseBillingWorksheetState = (state: RootState) => state.expenseBillingWorksheet
export default expenseBillingSlice.reducer
